<script>
  import ClientProfile from './ClientProfile.svelte';
  import ClientNotes from './ClientNotes.svelte';
  import { onMount, getContext, onDestroy } from 'svelte';
  import { client } from 'root/api/index.js';
  import { searchKeyByValue } from 'components/Helper.js';
  import { navigate } from 'svelte-routing';
  import { Modal } from 'bootstrap';
  import { masterData, getMasterData } from '../../stores/masterData.js';

  let id = 0;
  let units;
  let unitIds = {};
  let clientDetailSection;
  let showType = 1;

  let serverErrors = [];
  const showDialog = getContext('showDialog');
  let detail = {};
  let selectedUnit = { id: 1, name: '' };

  let clientModal;

  onMount(() => {
    clientModal = new Modal(document.getElementById('clientModal'), {
      keyboard: false,
    });
  });

  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = getMasterData().units;
        unitIds = getMasterData().unitId;
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
  });

  let clientFundProfileId;
  export const showModal = (params) => {
    id = params.id;
    clientFundProfileId = params.clientFundProfileId;
    fetchDetail(id);
    clientModal.show();
  };

  export const hide = () => {
    if (editTaskModal != undefined) {
      editTaskModal.hide();
    }
  };

  const changeShowType = (flag) => {
    showType = flag;
    setTimeout(() => {
      clientDetailSection.show(id, detail, unitIds, clientFundProfileId);
    }, 100);
  };

  const fetchDetail = (id) => {
    detail = {};
    changeShowType(1);
    client
      .clientGet({ id: id })
      .then((response) => {
        detail = response.data;
        selectedUnit = units[searchKeyByValue(units, 'id', response.data.unitId)];
        changeShowType(1);
      })
      .catch((err) => {
        serverErrors = [err.message];
        showDialog({ message: serverErrors });
      });
  };

  import TaskGroup from '../TaskDashboard/TaskGroup.svelte';
  import CreateGroup from '../TaskDashboard/CreateGroup.svelte';
  let createGroupModal;
  let createFilterGroupModal;
  let groupUsers = [];
  const saveGroup = (data) => {
    createGroupModal = new Modal(document.getElementById('creatGroupModal'), {
      keyboard: false,
    });
    createGroupModal.show();
    createFilterGroupModal.show(
      detail.users.map((item) => {
        item.id = item.userId;
        return item;
      }),
      data,
    );
    createGroupModal.show();
  };
  let taskGroupModal;
  const showGroup = () => {
    taskGroupModal.show(detail.id, 'client');
  };
</script>

<!-- Button trigger modal -->

<!-- Modal -->
<div
  class="modal fade slide-modal"
  id="clientModal"
  tabindex="-1"
  aria-labelledby="clientModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog w-100 add-task-modal h-100 m-0 float-end">
    <div class="modal-content">
      <div class="d-flex flex-column h-100">
        <div class="modal-header rounded-0 d-flex flex-column">
          <div class="d-flex flex-row justify-content-between w-100">
            <h5 class="mb-0 font-size-13 color-blue">
              {selectedUnit.name}
            </h5>
            <button
              type="button"
              class="close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="d-flex flex-row justify-content-between w-100 align-items-center">
            <h3 class="mb-0 font-size-16 text-break">
              {detail.name}
            </h3>
            <div>
              <button
                on:click={() => {
                  clientModal.hide();
                  navigate(`/redirect/task#action=viewTask&clientId=${id}`);
                }}
                class="color-blue bg-transparent border-0 text-nowrap"
              >
                <img
                  class="task-activity"
                  alt=""
                  src="/images/task_activity.svg"
                />
                View Tasks
              </button>
            </div>
          </div>
        </div>

        <div class="px-3 pt-2 pb-0 tabs">
          <div class="d-flex flex-row justify-content-between">
            <div class="tabs-header-block client-tab-header">
              <div class="header-tab-btn">
                <button
                  on:click={() => {
                    fetchDetail(id);
                  }}
                  class="mb-0 shadow-none bg-transparent border-0 rounded-0 me-3 {showType == 1
                    ? 'active'
                    : null}"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 100 100"
                  >
                    <path
                      d="M87.375 0H12.375C7.21875 0 3 4.21875 3 9.375V90.625C3 95.7812 7.21875 100 12.375 100H87.375C92.5312 100 96.75 95.7812 96.75 90.625V9.375C96.75 4.21875 92.5312 0 87.375 0ZM89.25 92.5H52.375H10.5V7.5H89.25V50V92.5ZM28 56.25H71.75V62.5H28V56.25ZM28 68.75H71.75V75H28V68.75ZM34.25 28.125C34.2504 26.8934 34.4934 25.674 34.9651 24.5364C35.4367 23.3987 36.1279 22.3651 36.999 21.4946C37.8701 20.624 38.9042 19.9336 40.0422 19.4627C41.1801 18.9918 42.3997 18.7496 43.6312 18.75C44.8628 18.7504 46.0822 18.9934 47.2199 19.4651C48.3575 19.9367 49.3911 20.6279 50.2617 21.499C51.1322 22.3701 51.8227 23.4042 52.2936 24.5422C52.7645 25.6801 53.0067 26.8997 53.0063 28.1313C53.0054 30.6185 52.0166 33.0035 50.2573 34.7617C48.4979 36.5198 46.1122 37.5071 43.625 37.5062C41.1378 37.5054 38.7527 36.5166 36.9946 34.7573C35.2364 32.9979 34.2492 30.6122 34.25 28.125ZM49.875 37.5H37.375C32.2188 37.5 28 40.3125 28 43.75V50H59.25V43.75C59.25 40.3125 55.0312 37.5 49.875 37.5Z"
                      fill=""
                    />
                  </svg>

                  Client Profile
                </button>
                <button
                  on:click={() => changeShowType(2)}
                  class="mb-0 shadow-none bg-transparent border-0 rounded-0 mx-3 {showType == 2
                    ? 'active'
                    : null}"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 100 100"
                  >
                    <path
                      d="M43.4833 60.1458C43.4833 58.6875 43.7333 57.2833 44.1917 55.9792H15.3708C12.8855 55.9792 10.502 56.9664 8.74465 58.7238C6.98728 60.4812 6 62.8647 6 65.35V67.7583C6 71.475 7.32917 75.075 9.74583 77.9042C16.2708 85.5458 26.2125 89.3208 39.3208 89.3208C40.975 89.3208 42.5833 89.2583 44.1375 89.1375C43.704 87.8513 43.4831 86.5031 43.4833 85.1458V82.9167C42.1458 83.0167 40.7542 83.0667 39.3167 83.0667C27.9083 83.0667 19.7167 79.9583 14.4917 73.8458C13.0414 72.1476 12.245 69.9874 12.2458 67.7542V65.35C12.2458 63.625 13.6458 62.225 15.3708 62.225H43.4833V60.1458ZM39.3167 6C42.0525 6 44.7616 6.53887 47.2892 7.58584C49.8169 8.63282 52.1135 10.1674 54.0481 12.1019C55.9826 14.0365 57.5172 16.3331 58.5642 18.8608C59.6111 21.3884 60.15 24.0975 60.15 26.8333C60.15 29.5692 59.6111 32.2783 58.5642 34.8059C57.5172 37.3335 55.9826 39.6302 54.0481 41.5647C52.1135 43.4993 49.8169 45.0338 47.2892 46.0808C44.7616 47.1278 42.0525 47.6667 39.3167 47.6667C33.7913 47.6667 28.4923 45.4717 24.5853 41.5647C20.6783 37.6577 18.4833 32.3587 18.4833 26.8333C18.4833 21.308 20.6783 16.0089 24.5853 12.1019C28.4923 8.19493 33.7913 6 39.3167 6V6ZM39.3167 12.25C37.4016 12.25 35.5052 12.6272 33.7359 13.3601C31.9665 14.093 30.3589 15.1672 29.0047 16.5214C27.6505 17.8755 26.5763 19.4832 25.8434 21.2525C25.1105 23.0219 24.7333 24.9182 24.7333 26.8333C24.7333 28.7484 25.1105 30.6448 25.8434 32.4141C26.5763 34.1835 27.6505 35.7911 29.0047 37.1453C30.3589 38.4995 31.9665 39.5737 33.7359 40.3066C35.5052 41.0395 37.4016 41.4167 39.3167 41.4167C43.1844 41.4167 46.8937 39.8802 49.6286 37.1453C52.3635 34.4104 53.9 30.7011 53.9 26.8333C53.9 22.9656 52.3635 19.2563 49.6286 16.5214C46.8937 13.7865 43.1844 12.25 39.3167 12.25V12.25ZM47.65 60.1458C47.65 57.9357 48.528 55.8161 50.0908 54.2533C51.6536 52.6905 53.7732 51.8125 55.9833 51.8125H85.15C87.3601 51.8125 89.4798 52.6905 91.0426 54.2533C92.6054 55.8161 93.4833 57.9357 93.4833 60.1458V85.1458C93.4833 87.356 92.6054 89.4756 91.0426 91.0384C89.4798 92.6012 87.3601 93.4792 85.15 93.4792H55.9833C53.7732 93.4792 51.6536 92.6012 50.0908 91.0384C48.528 89.4756 47.65 87.356 47.65 85.1458V60.1458ZM58.0667 64.3125C57.5141 64.3125 56.9842 64.532 56.5935 64.9227C56.2028 65.3134 55.9833 65.8433 55.9833 66.3958C55.9833 66.9484 56.2028 67.4783 56.5935 67.869C56.9842 68.2597 57.5141 68.4792 58.0667 68.4792H83.0667C83.6192 68.4792 84.1491 68.2597 84.5398 67.869C84.9305 67.4783 85.15 66.9484 85.15 66.3958C85.15 65.8433 84.9305 65.3134 84.5398 64.9227C84.1491 64.532 83.6192 64.3125 83.0667 64.3125H58.0667ZM58.0667 76.8125C57.5141 76.8125 56.9842 77.032 56.5935 77.4227C56.2028 77.8134 55.9833 78.3433 55.9833 78.8958C55.9833 79.4484 56.2028 79.9783 56.5935 80.369C56.9842 80.7597 57.5141 80.9792 58.0667 80.9792H83.0667C83.6192 80.9792 84.1491 80.7597 84.5398 80.369C84.9305 79.9783 85.15 79.4484 85.15 78.8958C85.15 78.3433 84.9305 77.8134 84.5398 77.4227C84.1491 77.032 83.6192 76.8125 83.0667 76.8125H58.0667Z"
                      fill=""
                    />
                  </svg>

                  Client Notes
                </button>
              </div>
            </div>
            <div>
              <button
                on:click={() => {
                  clientModal.hide();
                  navigate(`/redirect/task#action=addTask&clientId=${id}&unitId=${detail.unitId}`);
                }}
                class="color-blue bg-transparent shadow-none border-0"
                ><img
                  class="icon-10"
                  alt=""
                  src="/images/plus.svg"
                /> Create Task</button
              >

              <button
                disabled={detail.isEditable == false}
                on:click={() => {
                  clientModal.hide();
                  navigate(`/client/edit/${id}`);
                }}
                class="color-blue bg-transparent border-0"
              >
                <img
                  alt=""
                  class="mx-1 icon-12"
                  src="/images/pencil-gray.svg"
                />
                Edit</button
              >
            </div>
          </div>
        </div>
        <div
          class="tab-content h-100 page-content"
          id="pills-tabContent"
        >
          {#if showType == 1}
            <ClientProfile
              bind:this={clientDetailSection}
              clientModal={clientModal}
              viewGroup={() => {
                showGroup();
              }}
            />
          {/if}

          {#if showType == 2}
            <ClientNotes
              bind:this={clientDetailSection}
              clientModal={clientModal}
            />
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<TaskGroup
  bind:this={taskGroupModal}
  showGroup={(flag, data) => {
    if (flag == 'add') {
      saveGroup({
        clientId: detail.id,
        id: '',
        readonly: 0,
        name: '',
        users: [],
      });
    } else {
      saveGroup({
        clientId: detail.id,
        id: data.id,
        readonly: data.readonly,
        name: data.name,
        users: data.users,
      });
    }
  }}
/>
<CreateGroup
  bind:this={createFilterGroupModal}
  comeFrom="user"
  saveGroup={(event) => {
    client
      .taskFilterGroupSave(event)
      .then(async (result) => {
        createGroupModal.hide();
      })
      .catch((err) => {
        showDialog({ message: [err.message] });
      });
  }}
/>

<style lang="scss">
  .tabs {
    border-bottom: 1px solid $input-border-color;
  }
  .task-activity {
    position: relative;
    top: -4px;
  }
</style>
